import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import API from '@sesame/web-api';

import { ICustomer, ISalesorder, ISalesorderType, ILoadState } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { getCustomerCacheList, getCustomerCacheMap } from 'src/util/resources/CustomerCache';
import { getSalesorderTypeCacheList } from 'src/util/resources/SalesorderTypesCache';
import { EditSalesorderDetails } from 'src/pages/Salesorder/EditSalesorderDetails';
import { Spinner } from 'src/components/Spinner';



// Make a string based object to ease form manipulatin
type IFormData = { [Property in keyof ISalesorder]: string; } & { [key: string]: string };
type fieldNames = keyof IFormData;

type ICustomerMap = Map<number, string>;


interface ISalesorderCardProps {
  salesorderId: number;
}

export const SalesorderCard = ({ salesorderId }: ISalesorderCardProps) => {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [displayState, setDisplayState] = useState(ILoadState.NEW);
  const [customers, setCustomers] = useState<ICustomer[]>([]);
  const [customerMap, setCustomerMap] = useState<Map<number, string>>(new Map());
  const [origSalesorder, setOrigSalesorder] = useState<ISalesorder>();
  const [salesorderTypes, setSalesorderTypes] = useState<string[]>([]);
  const [salesorder, setSalesorder] = useState<ISalesorder>({
    salesorderId: 0,
    salesorderRef: '',
    customerId: 0,
    name: '',
    salesorderType: 'Sale',
    salesOpportunity: '',
    issue: '',
  });


  const save = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();

  }
  const onEditSave = () => {
    getSalesorder(salesorder.salesorderId);
  }

  const getCustomerList = () => {
    getAccessTokenSilently().then(accessToken => {

    getCustomerCacheList(accessToken)
      .then((list) => {
        setCustomers(list);
        getCustomerCacheMap(accessToken)
          .then(custMap => setCustomerMap(custMap));
      });
    })
  }

  const getSalesorderTypes = () => {
    getAccessTokenSilently().then(accessToken => {
    getSalesorderTypeCacheList(accessToken || '')
      .then((list) => {
        setSalesorderTypes(list.map(t => t.name));
      });
    })
  }

  const getSalesorder = (salesorderId: number) => {
    getAccessTokenSilently().then(accessToken => {
    API.get(accessToken, `api/v1/salesorder/${salesorderId}`)
      .then((response) => {
        if (!response) {
          Alert(AlertTypes.ERROR, 'Salesorder  Not Found');
          setDisplayState(ILoadState.ERROR);
          return;
        }
        const salesorder = response.data as ISalesorder;
        setSalesorder(salesorder);
        if (salesorder.originalSalesOrder) {
          getOrigSalesorder(salesorder.originalSalesOrder);
        } else {
          setDisplayState(ILoadState.READY);
        }
      })
      .catch((err) => {
        if (err.status === 404) {
          Alert(AlertTypes.ERROR, 'Salesorder Not Found');
          setDisplayState(ILoadState.ERROR);
          return;
        }
        console.log('Salesorders err: ' + JSON.stringify(err));
        setDisplayState(ILoadState.ERROR);
        Alert(AlertTypes.ERROR, 'Salesorders: ' + err.message);
      });
    })
  }

  const getOrigSalesorder = (origSalesorderId: number) => {
    getAccessTokenSilently().then(accessToken => {
    API.get(accessToken, `api/v1/salesorder/${origSalesorderId}`)
      .then((response) => {
        if (!response) {
          Alert(AlertTypes.ERROR, 'Salesorder  Not Found');
          setDisplayState(ILoadState.ERROR);
          return;
        }
        const salesorder = response.data as ISalesorder;
        setOrigSalesorder(salesorder);
        setDisplayState(ILoadState.READY);
      })
      .catch((err) => {
        Alert(AlertTypes.ERROR, 'Error loading original salesorder');
        setDisplayState(ILoadState.ERROR);
      });
    });
  }


  useEffect(() => {
    getCustomerList();
    getSalesorderTypes();
    getSalesorder(salesorderId);
  }, [getAccessTokenSilently])


  const cust = customers.find(c => c.customerId == salesorder.customerId);
  const customerName = cust ? cust.name : '';

  const origBCSalesorder = origSalesorder ? origSalesorder.salesorderRef : salesorder.originalSalesOrder;

  if (isLoading) {
    return <Spinner />
  }
  return <div>
    <h2 className="uk-card-title">
      <a href={`https://team-sesame.atlassian.net/browse/${salesorder.issue}`}>{salesorder.issue}</a>
      &nbsp; {customerName}
      <span className="uk-align-right">
        <EditSalesorderDetails
          salesorderId={salesorder.salesorderId}
          onSave={onEditSave}
        />
      </span>
    </h2>
    <p>
      {salesorder.name}
      <br />
      <b>{salesorder.salesorderType}</b>
      <br />
      {salesorder.originalSalesOrder ?
        <>Original sales order: <a href={'?salesorder=' + salesorder.originalSalesOrder}>{origBCSalesorder}</a><br /></> : ''
      }
      <label>Sales opportunity:</label> {salesorder.salesOpportunity}
      <br />
    </p>
  </div>
}
